import { gql } from '@apollo/client'

// implemented with new codegen here "src/gql/queries/userProfileAdminUser.graphql"
// import and use query "useUserProfileAdminUserQuery"
export const userProfileQuery = gql`
    query userProfileAdminUser($id: Int!) {
        user(id: $id) {
            id
            email
            displayName
            firstName
            lastName
            phoneNumber
            updatedAt
            enabled
            createdAt
            isUserLockedOut
            lockoutLoginUntil
            emailVerificationSentDate
            emailVerificationStatus
            roles {
                id
                name
                source
            }
            businessAccountMembership {
                businessAccount {
                    id
                    name
                    isEnabled
                    isTeamsFeatureEnabled
                }
                user {
                    id
                    enabled
                }
            }
        }
    }
`

export const deleteUserAccountByAdmin = gql`
    mutation deleteUserAccountByAdmin($id: Int!) {
        adminUser(userId: $id) {
            deleteAccount {
                id
            }
        }
    }
`

export const is2FAEnalbedForUserQuery = gql`
    query is2FAEnalbedForUserQueryAdminUserProfile($id: Int!) {
        user(id: $id) {
            id
            is2faEnabled
        }
    }
`

export const disable2FAForUserMutation = gql`
    mutation disable2FAForUserAdminUserProfile($id: Int!) {
        adminUser(userId: $id) {
            disable2FA {
                id
                is2faEnabled
            }
        }
    }
`

export const adminRolesQuery = gql`
    query adminRolesQuery {
        me {
            id
            roles {
                id
                name
            }
        }
    }
`
